module.exports = __webpack_public_path__ + "img/diskette.6f63b15f.svg";